(function (w, d, t, u, n, a, m) {
    w['MauticTrackingObject'] = n;
    w[n] = w[n] || function () {
        (w[n].q = w[n].q || []).push(arguments)
    }, a = d.createElement(t),
        m = d.getElementsByTagName(t)[0];
    a.async = 1;
    a.src = u;
    m.parentNode.insertBefore(a, m)
})(window, document, 'script', 'https://crm.petlink.net/mtc.js', 'mt');

jQuery(function ($) {
    function isEmpty(obj) {
        for (var prop in obj) {
            if (obj.hasOwnProperty(prop)) {
                return false;
            }
        }
        return (JSON.stringify(obj) === JSON.stringify({})) || (JSON.stringify(obj) === JSON.stringify([]));
    }

    function isEmailValid(value) {
        var emailReg = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
        return emailReg.test(value);
    }

    var petlinkUrl = "https://www.petlink.net/";
    $.ajax(petlinkUrl + 'wp-admin/admin-ajax.php?action=get_owner_details',
        {
            cache: false,
            dataType: "jsonp",
            success: function (response) {
                if (isEmpty(response)) {
                    return;
                }
                if (!response.hasOwnProperty('email') || !response.email || !isEmailValid(response.email)) {
                    return;
                }
                var data = {email: response.email};
                mt('send', 'pageview', data);
            }
        });
});